import React from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Col, Container, Row } from 'reactstrap';
import Sidebar from '../JobCardView/Sidebar';
import CardsClass from '../JobCardView/Cards';

const ListViewContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='List View' parent='Job Search' title='List View' />
      <Row>
        <Sidebar />
        <Col xxl='9' xl='8' className='box-col-8'>
          <Row>
            <CardsClass limit={8} jobClass='col-xl-12 box-col-12' ribbion={false} />
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ListViewContainer;
